import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Form,
    Select,
    Input,
    Divider,
    Upload,
    Space,
    DatePicker,
    Table,
} from 'antd'
import { InboxOutlined, ProductOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { SeeAttachment } from '../../Components/SeeAttachment';
import { formatDate } from '../../Utils/Common';
import dayjs from 'dayjs';

const { Option } = Select;
const { Item } = Form;
const { TextArea } = Input;

const AddEditTaskManager = () => {
    const [addEditForm] = Form.useForm();
    const { id, type } = useParams();
    const { callPost, loading } = usePostRequest(()=>{
        addEditForm.resetFields();
        navigate('/task-manager')
    });
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false);
    const [newAttachment, setNewAttachment] = useState([]);
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [managerDetails, setManagerDetails] = useState({
        name: '',
    });
    const [propertyData, setPropertyData] = useState([]);
    const [personnelData, setPersonnelData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;
    const stutus_data = [
        {
            name: 'In-progress',
            value: 'in-progress',
        },
        {
            name: 'To Do',
            value: 'to do',
        },
        {
            name: 'Done',
            value: 'done',
        },
        {
            name: 'Cancelled',
            value: 'cancelled',
        },
    ];

    const priority = [
        {
            name: 'High',
            value: 'high',
        },
        {
            name: 'Medium',
            value: 'medium',
        },
        {
            name: 'Low',
            value: 'low',
        },
    ];

    const columns2 = [
        {
            title: 'Date Added',
            dataIndex: 'added_on',
            key: 'added_on',
            width: '30%',
            render: (date) => formatDate(date),
        },
        {
            title: 'Attachments',
            dataIndex: 'link',
            key: 'link',
        },
    ]; 

    const fileUrlFormat = (files) => {
        if(files){
            return files?.map(file => ({
                uid: file.id,
                id: file.id,
                name: file.file_name,
                status: "done",
                url: file.file_url,
                fileType: file.file_type
            }));
        }
    };
    

    async function fetchTaskManagerData() {
        setIsLoading(true)
        const response = await UseGetRequest("task_managers/get", {task_manager_id: id});

        if (response?.data) {
            const data = response?.data?.data[0]    

            let attachment = data?.attachments?.map((file) => ({
                ...file,
                link: (
                <SeeAttachment
                    attachments={[
                    { file_url: file.file_url, file_name: file.file_name },
                    ]}
                />
                ),
            })); 

            setNewAttachment(attachment);
            setAttachmentsData(fileUrlFormat(data?.attachments))
            setManagerDetails(data);
            addEditForm.setFieldsValue({
                property_id: data.property_id,
                personnel_id: data.personnel_id,
                property_address: data.property_address,
                property_type: data.property_type,
                status: data.status,
                summary: data.summary,
                description: data.description,
                category_id: data.category_id,
                priority: data.priority,
                due_date: dayjs(data.due_date),
            });

        } else {
            setManagerDetails([]);
        }
        setIsLoading(false)
    };

    async function fetchPropertyData  () {
        const response = await UseGetRequest("properties/get", {property_id: ''});
        if (response?.data) {
          setPropertyData(response?.data?.data);
        } else {
          setPropertyData([])
        }    
    };
    async function fetchPersonnelData  () {
        const response = await UseGetRequest("personnels/get", {personnel_id: ''});
        if (response?.data) {
          setPersonnelData(response?.data?.data);
        } else {
          setPersonnelData([])
        }    
    };
    async function fetchCategoryData  () {
        const response = await UseGetRequest("categories/get", {category_id: ''});
        if (response?.data) {
          setCategoryData(response?.data?.data);
        } else {
          setCategoryData([])
        }    
    };

    
    const handleParkingType = () => {
        if(type === "edit"){
            handleEditParkingUnit();
        } else {
            handleAddParkingUnit();
        }
    };

    const handleAddParkingUnit = () => {
        addEditForm.validateFields().then(values => {
            const newValues = {
                property_id: values.property_id,
                personnel_id: values.personnel_id,
                status: values.status,
                summary: values.summary,
                description: values.description || '',
                category_id: values.category_id,
                priority: values.priority,
                due_date: values.due_date.format('YYYY-MM-DD'),
            }

            const file = attachmentsData.map((file) => {
                return file.originFileObj;
            });

            var finalValues = Object.entries({...newValues, attachments: file}).map(([key, value]) => ({
                key,
                value,
            }));

            callPost(
                "task_managers/create", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
            toast.error('Validation Failed ', errorInfo);
        });
    };

    const handleEditParkingUnit = () => {
        addEditForm.validateFields().then(values => {
            const newValues = {
                task_manager_id: id,
                property_id: values.property_id,
                personnel_id: values.personnel_id,
                status: values.status,
                summary: values.summary,
                description: values.description || '',
                category_id: values.category_id,
                priority: values.priority,
                due_date: values.due_date.format('YYYY-MM-DD'),
            }

            const file = attachmentsData.map((data) => {
                if(data.originFileObj){
                    return data.originFileObj;
                }
                return data
            });
    
            const attch_ids = attachmentsData.map((data) => {
                if(data.id){
                    return data.id;
                }
                return ""
            });
    
            
            var finalValues = Object.entries({...newValues, attachments: file, attachment_ids: attch_ids}).map(([key, value]) => ({
                key,
                value,
            }));

            callPost(
                "task_managers/update", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed ', errorInfo);
        });
    };

    const handlePropertyType = (value) => {
        var type = ''
        const details = propertyData.find(item => item.id === value);
        if(details.property_type === 'commercial_building'){
            type = 'Commerical Building'
        } else if (details.property_type === 'residential_building') {
            type = 'Residential Building'
        } else if (details.property_type === 'raw_lot') {
            type = 'Raw Lot'
        } else if (details.property_type === 'condominium') {
            type = 'Condominium'
        }
        setManagerDetails({
          ...managerDetails,
          property_id: details.id,
          property_address: details.address,
          property_type: type,
        });
        addEditForm.setFieldsValue({
            property_address: details.address,
            property_type: type,
            property_id: details.id,
            property_name: details.name,
        })
    };
    const handleDeleteAttachment = (file) => {
        const updatedAttachments = attachmentsData.filter(item => item !== file);
        setAttachmentsData(updatedAttachments);
    };
    const normFile = (e) => {
        if (Array.isArray(e)) {
            setAttachmentsData(e)
        }
        setAttachmentsData(e?.fileList)
        
    };

    useEffect(() => {
        fetchPropertyData();
        fetchPersonnelData();
        fetchCategoryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(type === "edit" && id){
            fetchTaskManagerData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, type]);

    return (
        <Layout className='page'>
            <Navbar navKey={'task_manager_nav'}/>
            <Layout className='content-container overflow-y p-4'>
                <Row>
                    <Col span={24} className='header-container'>
                        {type.toUpperCase()} TASK MANAGER
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form 
                            initialValues={managerDetails} 
                            form={addEditForm} 
                            layout="vertical"
                        >
                            <Divider className='divider-text'>Task Information</Divider>
                            <Row className='responsive-inline responsive-width'>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Property"
                                        name="property_id"
                                        rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <Select 
                                            placeholder="Select a property" 
                                            onChange={(e) => handlePropertyType(e)}
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                            disabled={type === 'edit'}
                                        >
                                            {propertyData.map((option) => (
                                                <Option key={option.id} value={option.id}>{option.name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={5} className='p-2'>
                                    <Item
                                        label="Type"
                                        name="property_type"
                                    >
                                        <Input disabled/>
                                    </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                    <Item
                                    label="Address"
                                    name="property_address"
                                    >
                                        <Input disabled/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row className='responsive-inline responsive-width'>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Assigned To"
                                        name="personnel_id"
                                        rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <Select 
                                            placeholder="Select a Name" 
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {personnelData.map((option) => (
                                                <Option key={option.id} value={option.id}>{option.name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={5} className='p-2'>
                                    <Item
                                        label="Status"
                                        name="status"
                                        rules={[{ required: true, message: 'Please enter your Status!' }]}
                                    >
                                        <Select 
                                            placeholder="Select a Status" 
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {stutus_data.map((option) => (
                                                <Option key={option.value} value={option.value}>{option.name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='p-2'>
                                    <Item
                                        label="Summary"
                                        name="summary"
                                        rules={[{ required: true, message: 'Please enter your Summary' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='p-2'>
                                    <Item
                                        label="Description"
                                        name="description"
                                        // rules={[{ required: true, message: 'Please select your Agent Fee' }]}
                                    >
                                        <TextArea/>
                                    </Item>
                                </Col>
                            </Row>
                            
                            <Row className='responsive-inline responsive-width'>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Category"
                                        name="category_id"
                                        rules={[{ required: true, message: 'Please enter your Category!' }]}
                                    >
                                        <Select 
                                            placeholder="Select a Category" 
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {categoryData.map((option) => (
                                                <Option key={option.id} value={option.id}>{option.name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Priority"
                                        name="priority"
                                        rules={[{ required: true, message: 'Please enter your Priority!' }]}
                                    >
                                        <Select 
                                            placeholder="Select a Priority" 
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {priority.map((option) => (
                                                <Option key={option.value} value={option.value}>{option.name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Due Date"
                                        name="due_date"
                                        rules={[{ required: true, message: 'Please enter your Date Paid!' }]}
                                    >
                                        <DatePicker style={{width:'100%'}}/>
                                    </Item>
                                </Col>
                            </Row>

                            {
                                id && (
                                <Row className='my-5'>
                                    <Col span={24}>
                                        <Table 
                                            columns={columns2} 
                                            dataSource={newAttachment} 
                                            pagination={false}
                                            loading={{
                                            indicator: customSpinner,
                                            spinning: isLoading,
                                            }}
                                        />
                                    </Col>
                                </Row>
                                )
                            }

                            <Row className='responsive-inline responsive-width pb-4'>
                                <Col span={24} className='p-2'>
                                    {/* <Item
                                    label="Attachment"
                                    >
                                    <Item name="attachments" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                                        <Upload.Dragger name="files" action="/upload.do">
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                        <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                                        </Upload.Dragger>
                                    </Item>
                                    </Item> */}
                                    <Item 
                                        label="Attachment"
                                        name="attachments" 
                                        // valuePropName="fileList" 
                                        getValueFromEvent={normFile} 
                                        noStyle
                                    >
                                    <Upload.Dragger 
                                        multiple
                                        name="files" 
                                        // action="/upload.do"
                                        fileList={attachmentsData}              
                                        beforeUpload={() => false}
                                        onRemove={handleDeleteAttachment}
                                    >
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                        <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                                    </Upload.Dragger>
                                    </Item>
                                </Col>
                            </Row>
                                      
                            <Row className='btn-footer'>
                                <Space className='p-2'>
                                    <Button
                                        onClick={() => navigate('/task-manager')}
                                        className='cancel-color btn-header'
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        onClick={handleParkingType}
                                        loading={loading}
                                        type='primary'
                                        className='button-color btn-header'
                                    >
                                        Save
                                    </Button>
                                </Space>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default AddEditTaskManager
